export default "__VITE_ASSET__HwPg9ILO__"